
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { FileText, FileSpreadsheet } from 'lucide-react';
import QuickbooksIntegrationSettings from '../QuickbooksIntegrationSettings';
import GoogleSheetsIntegrationSettings from '../GoogleSheetsIntegrationSettings';
import CSVUploadIntegration from '../CSVUploadIntegration';

interface DataChannelIntegrationsProps {
  onSaved: () => Promise<void>;
}

const DataChannelIntegrations: React.FC<DataChannelIntegrationsProps> = ({ onSaved }) => {
  const [dataChannelTab, setDataChannelTab] = useState('quickbooks');

  return (
    <Tabs value={dataChannelTab} onValueChange={setDataChannelTab} className="w-full">
      <TabsList className="mb-4 grid w-full max-w-md grid-cols-3">
        <TabsTrigger value="quickbooks" className="flex items-center">
          <FileText className="mr-2 h-4 w-4" />
          <span>QuickBooks</span>
        </TabsTrigger>
        <TabsTrigger value="google-sheets" className="flex items-center">
          <FileSpreadsheet className="mr-2 h-4 w-4" />
          <span>Google Sheets</span>
        </TabsTrigger>
        <TabsTrigger value="csv-upload" className="flex items-center">
          <FileText className="mr-2 h-4 w-4" />
          <span>CSV Upload</span>
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="quickbooks">
        <QuickbooksIntegrationSettings onSaved={onSaved} />
      </TabsContent>
      
      <TabsContent value="google-sheets">
        <GoogleSheetsIntegrationSettings onSaved={onSaved} />
      </TabsContent>
      
      <TabsContent value="csv-upload">
        <CSVUploadIntegration onSaved={onSaved} />
      </TabsContent>
    </Tabs>
  );
};

export default DataChannelIntegrations;
